export default __webpack_public_path__ + "static/media/Step2GIF2.09063205.gif";